/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

interface IRequestInfo extends Pick<IApplicationLog,
'host' | 'uri_path' | 'orig_uri' | 'http_version' | 'request_length' |
'request_content_type' | 'rewritten_uri_path'
> {
    requestMethod?: IApplicationLog['method'];
    uri?: IApplicationLog['uri_path'];
    uriQuery?: IApplicationLog['uri_query'];
    userAgent?: IApplicationLog['user_agent'];
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting request info from an L7 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'requestInfo',
})
export class RequestInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): IRequestInfo {
        if (!log) {
            return {};
        }

        const {
            host,
            method,
            uri_path,
            uri_query,
            rewritten_uri_path,
            orig_uri,
            user_agent,
            http_version,
            request_length,
            request_content_type,
        } = log;

        return {
            host,
            requestMethod: method,
            uri: uri_path,
            uriQuery: uri_query,
            rewritten_uri_path,
            orig_uri,
            userAgent: user_agent,
            http_version,
            request_length,
            request_content_type,
        };
    }
}
